(function () {
var SCROLL_KEY = 'pz1-flavor-scroll';

function init(root) {
  if (root.dataset.ready) return;
  root.dataset.ready = '1';

  var variants = JSON.parse(root.querySelector('[data-pz1-variants]').textContent);
  var threshold = parseInt(root.dataset.threshold, 10) || 7000;
  var ROLL = root.dataset.roll, CAN = root.dataset.can;
  var title = root.dataset.title;
  var initialStrength = root.dataset.strength;
  var state = { strength: null, pack: 3, canQty: 1 };

  var segBtns = root.querySelectorAll('[data-strength]');
  var packBtns = root.querySelectorAll('[data-pack]');
  var buy = root.querySelector('[data-pz1-buy]');
  var restock = root.querySelector('[data-pz1-restock]');
  var errBox = root.querySelector('[data-pz1-error]');
  var form = root.querySelector('[data-pz1-form]');
  var idInput = root.querySelector('[data-pz1-id]');
  var qtyInput = root.querySelector('[data-pz1-qty]');
  var atc = root.querySelector('[data-pz1-atc]');
  var sticky = root.querySelector('[data-pz1-sticky]') || document.querySelector('body > .pz1-sticky');
  sticky.classList.add('pz1');
  document.body.appendChild(sticky); // keep position:fixed clear of transformed ancestors

  // Can counter, shown when Single Can is selected
  var stepper = document.createElement('div');
  stepper.className = 'pz1-canqty';
  stepper.hidden = true;
  stepper.innerHTML = '<span>How many tins?</span><div class="pz1-stepper"><button type="button" data-step="-1" aria-label="One less tin">−</button><input type="number" inputmode="numeric" min="1" value="1" aria-label="Number of tins" data-can-count><button type="button" data-step="1" aria-label="One more tin">+</button></div>';
  var packsEl = root.querySelector('.pz1-packs');
  if (packsEl) packsEl.insertAdjacentElement('afterend', stepper);
  var countInput = stepper.querySelector('[data-can-count]');

  function money(c) { return '$' + (c / 100).toFixed(2); }
  function find(s, pack) {
    for (var i = 0; i < variants.length; i++) if (variants[i].strength === s && variants[i].pack === pack) return variants[i];
    return null;
  }
  function canBuy(v, q) { return !!v && v.available && (v.inv === null || v.inv >= q); }
  function strengthHasStock(s) { return canBuy(find(s, ROLL), 1) || canBuy(find(s, CAN), 1); }
  function maxCans(v) { return v && v.inv !== null ? Math.max(v.inv, 1) : 99; }
  function mg(s) { return String(s).replace(/mg/i, '').trim() + ' mg'; }

  function current() {
    var roll = find(state.strength, ROLL), can = find(state.strength, CAN);
    if (state.pack === 'can') return canBuy(can, 1) ? { v: can, q: Math.min(state.canQty, maxCans(can)), cans: Math.min(state.canQty, maxCans(can)) } : null;
    return canBuy(roll, state.pack) ? { v: roll, q: state.pack, cans: state.pack * 5 } : null;
  }

  function pickPack() {
    if (current()) return;
    var roll = find(state.strength, ROLL);
    var order = [3, 5, 1];
    for (var i = 0; i < order.length; i++) if (canBuy(roll, order[i])) { state.pack = order[i]; return; }
    state.pack = 'can';
  }

  function render() {
    var s = state.strength;
    var roll = find(s, ROLL), can = find(s, CAN);
    pickPack();

    segBtns.forEach(function (b) {
      var bs = b.getAttribute('data-strength');
      b.setAttribute('aria-pressed', bs === s ? 'true' : 'false');
      b.classList.toggle('is-out', !strengthHasStock(bs));
    });

    packBtns.forEach(function (b) {
      var key = b.getAttribute('data-pack');
      var isCan = key === 'can';
      var q = isCan ? 1 : parseInt(key, 10);
      var v = isCan ? can : roll;
      var ok = canBuy(v, q);
      var total = v ? v.price * q : 0;
      b.disabled = !ok;
      b.setAttribute('aria-pressed', String(state.pack) === key ? 'true' : 'false');
      b.classList.toggle('ships-free', ok && total >= threshold);
      b.querySelector('[data-pack-price]').textContent = v ? money(total) : '';
      var meta = isCan ? '1 tin' : (q * 5) + ' tins';
      if (v && v.available && v.inv !== null && v.inv < q) meta = 'Only ' + v.inv + ' left';
      else if (!v || !v.available) meta = 'Restocking';
      b.querySelector('[data-pack-meta]').textContent = meta;
    });

    var canMax = maxCans(can);
    if (state.canQty > canMax) state.canQty = canMax;
    stepper.hidden = state.pack !== 'can';
    countInput.value = state.canQty;
    countInput.max = canMax;
    stepper.querySelector('[data-step="-1"]').disabled = state.canQty <= 1;
    stepper.querySelector('[data-step="1"]').disabled = state.canQty >= canMax;

    var sel = current();
    var nothing = !sel;
    buy.style.display = nothing ? 'none' : '';
    restock.classList.toggle('is-on', nothing);
    atc.style.display = nothing ? 'none' : '';

    if (sel) {
      var total = sel.v.price * sel.q;
      var label = sel.v.pack === ROLL ? sel.q + ' roll' + (sel.q > 1 ? 's' : '') : sel.q + ' tin' + (sel.q > 1 ? 's' : '');
      atc.querySelector('[data-atc-price]').textContent = money(total) + ' →';
      sticky.querySelector('[data-sticky-label]').textContent = title + ' · ' + mg(s) + ' · ' + label;
      sticky.querySelector('[data-sticky-note]').textContent = total >= threshold ? 'Free shipping' : '';
      sticky.querySelector('[data-sticky-price]').textContent = money(total) + ' →';
      idInput.value = sel.v.id;
      qtyInput.value = sel.q;
    } else {
      var any = roll || can;
      if (any) { idInput.value = any.id; qtyInput.value = 1; }
    }
    // URL first: the restock app reads ?variant= when the form fires "change".
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', idInput.value);
      window.history.replaceState(window.history.state, '', url.toString());
    } catch (e) {}
    if (form) form.dispatchEvent(new Event('change', { bubbles: true }));

    sticky.dataset.available = sel ? '1' : '0';
    updateSticky();
  }

  function setError(msg) { errBox.textContent = msg || ''; errBox.classList.toggle('is-on', !!msg); }

  function addToCart(variant, qty, btn) {
    if (!variant) return;
    setError('');
    if (btn) btn.classList.add('is-loading');
    var fd = new FormData();
    fd.append('id', variant.id);
    fd.append('quantity', qty);
    var modal = window.theme && window.theme.settings && window.theme.settings.cart_type === 'modal';
    if (modal) {
      fd.append('sections', 'cart-items,cart-footer,cart-item-count');
      fd.append('sections_url', window.location.pathname);
    }
    fetch((window.theme && window.theme.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.status) { setError(data.description || data.message || 'Could not add to cart.'); return; }
        if (modal) document.body.dispatchEvent(new CustomEvent('shapes:modalcart:afteradditem', { bubbles: true, detail: { response: data } }));
        else if (window.PZCart) window.PZCart.open();
        else window.location.href = (window.theme && window.theme.routes.cart_url) || '/cart';
      })
      .catch(function () { setError('Could not add to cart. Please try again.'); })
      .finally(function () { if (btn) btn.classList.remove('is-loading'); });
  }

  segBtns.forEach(function (b) {
    b.addEventListener('click', function () { state.strength = b.getAttribute('data-strength'); render(); });
  });
  packBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      var key = b.getAttribute('data-pack');
      state.pack = key === 'can' ? 'can' : parseInt(key, 10);
      render();
    });
  });
  stepper.querySelectorAll('[data-step]').forEach(function (b) {
    b.addEventListener('click', function () {
      state.canQty = Math.max(1, state.canQty + parseInt(b.getAttribute('data-step'), 10));
      render();
    });
  });
  countInput.addEventListener('change', function () {
    var n = parseInt(countInput.value, 10);
    state.canQty = isNaN(n) || n < 1 ? 1 : n;
    render();
  });
  // The ATC is a plain button so other scripts that listen for product-form submits can't take over the add.
  atc.setAttribute('type', 'button');
  atc.addEventListener('click', function () {
    var sel = current();
    if (sel) addToCart(sel.v, sel.q, atc);
  });
  form.addEventListener('submit', function (e) { e.preventDefault(); });
  sticky.querySelector('[data-sticky-add]').addEventListener('click', function (e) {
    var sel = current();
    if (sel) addToCart(sel.v, sel.q, e.currentTarget);
  });

  // Strength help opens the FAQ answer
  var help = root.querySelector('[data-pz1-strength-help]');
  if (help) help.addEventListener('click', function (e) {
    var d = root.querySelector('#pz1-faq-strength');
    if (!d) return;
    e.preventDefault();
    d.open = true;
    d.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  // "Read all reviews" jumps to the full Loox section below
  var all = root.querySelector('[data-pz1-all-reviews]');
  if (all) all.addEventListener('click', function (e) {
    var target = document.querySelector('[id$="__reviews"]') || document.getElementById('looxReviews');
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  // Gallery
  var main = root.querySelector('[data-pz1-main]');
  root.querySelectorAll('[data-pz1-thumb]').forEach(function (t) {
    t.addEventListener('click', function () {
      var vid = t.getAttribute('data-video');
      if (vid) {
        main.innerHTML = '';
        var v = document.createElement('video');
        v.src = vid; v.autoplay = true; v.muted = true; v.loop = true; v.playsInline = true; v.setAttribute('playsinline', '');
        main.appendChild(v);
      } else {
        var img = main.querySelector('img');
        if (!img) { main.innerHTML = ''; img = document.createElement('img'); main.appendChild(img); }
        img.removeAttribute('srcset'); img.src = t.getAttribute('data-pz1-thumb'); img.alt = title;
      }
      root.querySelectorAll('[data-pz1-thumb]').forEach(function (o) { o.setAttribute('aria-current', o === t ? 'true' : 'false'); });
    });
  });

  // Flavor switching: keep the shopper at the picker and warm up the next page
  root.querySelectorAll('[data-pz1-flavor]').forEach(function (a) {
    function prefetch() {
      if (a.dataset.prefetched) return;
      a.dataset.prefetched = '1';
      var l = document.createElement('link');
      l.rel = 'prefetch'; l.href = a.href;
      document.head.appendChild(l);
    }
    a.addEventListener('mouseenter', prefetch);
    a.addEventListener('touchstart', prefetch, { passive: true });
    a.addEventListener('click', function () {
      if (a.classList.contains('is-current')) return;
      try {
        var picker = root.querySelector('.pz1-flavors');
        sessionStorage.setItem(SCROLL_KEY, String(picker.getBoundingClientRect().top));
      } catch (e) {}
      a.classList.add('is-loading');
    });
  });
  try {
    var saved = sessionStorage.getItem(SCROLL_KEY);
    if (saved !== null) {
      sessionStorage.removeItem(SCROLL_KEY);
      var picker = root.querySelector('.pz1-flavors');
      var offset = parseFloat(saved);
      if (picker && !isNaN(offset)) {
        if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
        window.scrollTo(0, window.scrollY + picker.getBoundingClientRect().top - offset);
      }
    }
  } catch (e) {}

  // Sticky bar whenever the main Add to cart button is off screen (mobile only; hidden on desktop by CSS)
  var buyboxVisible = true;
  var buybox = root.querySelector('[data-pz1-buybox]');
  function updateSticky() {
    var on = !buyboxVisible && sticky.dataset.available === '1';
    sticky.classList.toggle('is-on', on);
    sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
  }
  function checkBuybox() {
    var target = atc && atc.offsetParent ? atc : buybox;
    var r = target.getBoundingClientRect();
    var next = r.bottom > 0 && r.top < window.innerHeight;
    if (next !== buyboxVisible) { buyboxVisible = next; updateSticky(); }
  }
  window.addEventListener('scroll', checkBuybox, { passive: true });
  window.addEventListener('resize', checkBuybox);

  // Initial strength: a linked variant wins if it has stock; otherwise prefer rolls in stock.
  var strengths = Array.prototype.map.call(segBtns, function (b) { return b.getAttribute('data-strength'); });
  var ordered = [initialStrength].concat(strengths.filter(function (x) { return x !== initialStrength; }));
  var linked = /[?&]variant=/.test(window.location.search);
  function hasRoll(x) { return canBuy(find(x, ROLL), 1); }
  if (linked && strengthHasStock(initialStrength)) state.strength = initialStrength;
  else state.strength = ordered.filter(hasRoll)[0] || ordered.filter(strengthHasStock)[0] || initialStrength || strengths[0];
  render();
  checkBuybox();
}

function boot() { document.querySelectorAll('.pz1[data-pz1-root]').forEach(init); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
document.addEventListener('shopify:section:load', boot);
})();
